import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { IxModule } from '@siemens/ix-angular';
import { DataGridComponent } from './components/data-grid/data-grid.component';
import { ErrorPopupComponent } from './components/error-popup/error-popup.component';
import { HeaderComponent } from './components/header/header.component';
import { UnauthorisedComponent } from './components/unauthorised/unauthorised.component';
import { InputFileComponent } from './components/input-file-component/input-file-component';

@NgModule({
  declarations: [HeaderComponent, ErrorPopupComponent, UnauthorisedComponent, DataGridComponent, InputFileComponent],
  imports: [CommonModule, MatProgressBarModule, FormsModule, IxModule.forRoot()],
  exports: [
    HeaderComponent,
    ErrorPopupComponent,
    UnauthorisedComponent,
    MatProgressBarModule,
    FormsModule,
    IxModule,
    DataGridComponent,
    InputFileComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
